import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgN600DashboardIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 500 500",
	style: { enableBackground: "new 0 0 500 500" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M250,218.01c-17.64,0-31.99,14.35-31.99,31.99s14.35,31.99,31.99,31.99S282,267.64,282,250 c0-5.68-1.49-11.01-4.1-15.64l76.65-76.65c3.38-3.38,3.38-8.87,0-12.25c-3.38-3.38-8.87-3.38-12.25,0l-76.65,76.65 C261.02,219.5,255.68,218.01,250,218.01z M250,264.67c-8.09,0-14.67-6.58-14.67-14.67c0-8.09,6.58-14.67,14.67-14.67 c8.09,0,14.67,6.58,14.67,14.67C264.67,258.09,258.09,264.67,250,264.67z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M348.87,192.89c-2.39-4.14-7.69-5.56-11.84-3.16c-4.14,2.39-5.56,7.69-3.16,11.84 c8.48,14.66,12.96,31.41,12.96,48.44c0,53.39-43.44,96.82-96.82,96.82c-53.39,0-96.83-43.44-96.83-96.82 c0-53.39,43.44-96.83,96.83-96.83c17.03,0,33.78,4.48,48.43,12.96c4.14,2.4,9.44,0.98,11.84-3.16c2.4-4.14,0.98-9.44-3.16-11.84 c-17.29-10.01-37.04-15.29-57.11-15.29c-62.95,0-114.16,51.21-114.16,114.16c0,62.94,51.21,114.15,114.16,114.15 c62.94,0,114.15-51.21,114.15-114.15C364.15,229.94,358.87,210.19,348.87,192.89z"
	})] })]
});
const ForwardRef = forwardRef(SvgN600DashboardIcon);
export { ForwardRef as ReactComponent };
